<template>
  <Dropdown :transfer="true" trigger="click" @on-click="actionTrigger" v-if="show">
    <Modal :title="`重命名「${container.Name}」`" v-model="renameModal">
      <Form :model="renameForm" ref="renameForm" :rules="renameFormRules" :label-width="80">
        <FormItem label="容器名称" prop="name">
          <Input v-model="renameForm.name"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="rename" :loading="renameSubmitting">提交</Button>
        <Button @click="renameModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Button type="dashed" size="small">
      更多操作
      <Icon type="ios-arrow-down"></Icon>
    </Button>
    <DropdownMenu slot="list">
      <DropdownItem name="start" v-if="container.State.Status === 'exited'">
        <Icon style="font-family: 'iconfont'" type="iconfont icon-run" color="#19be6b"/>
        <span class="container-action-span">启动容器</span>
      </DropdownItem>
      <DropdownItem name="restart" v-if="container.State.Status === 'running' || container.State.Status === 'paused'">
        <Icon type="md-refresh-circle" color="#ff9900" size="15" />
        <span class="container-action-span">重启</span>
      </DropdownItem>
      <DropdownItem name="unpause" v-if="container.State.Status === 'paused'">
        <Icon type="md-checkmark-circle" color="#19be6b" size="15"/>
        <span class="container-action-span">恢复</span>
      </DropdownItem>
      <DropdownItem name="stop" v-if="container.State.Status === 'running' || container.State.Status === 'paused'">
        <Icon style="font-family: 'iconfont'" type="iconfont icon-stop" color="#ed4014"/>
        <span class="container-action-span">停止容器</span>
      </DropdownItem>
      <DropdownItem name="pause" v-if="container.State.Status === 'running'">
        <Icon style="font-family: 'iconfont'" type="iconfont icon-pause" color="#ff9900"/>
        <span class="container-action-span">暂停容器</span>
      </DropdownItem>
      <!--<DropdownItem name="resize">-->
        <!--<Icon style="font-family: 'iconfont'" type="iconfont icon-ResizePlus"/>-->
        <!--<span class="container-action-span">扩容/压缩</span>-->
      <!--</DropdownItem>-->
      <DropdownItem name="rename">
        <Icon style="font-family: 'iconfont'" type="iconfont icon-rename"/>
        <span class="container-action-span">重命名</span>
      </DropdownItem>
      <DropdownItem name="delete" v-if="container.State.Status === 'exited' || container.State.Status === 'created'">
        <Icon style="font-family: 'iconfont'" type="iconfont icon-delete" color="#ed4014"/>
        <span :style="{color: '#ed4014'}" class="container-action-span">销毁容器</span>
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import { deleteContainer, renameContainer, startContainer, restartContainer, stopContainer,
  pauseContainer, unpauseContainer } from '@/api/container/container'

export default {
  name: 'ActionMenu',
  components: {
  },
  props: {
    container: Object,
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      renameModal: false,
      renameForm: {
        name: ''
      },
      renameFormRules: {
        name: {required: true, message: '容器名称是必填的', trigger: 'blur'}
      },
      renameSubmitting: false,
      backParams: null
    }
  },
  methods: {
    actionTrigger (name, backParams) {
      this.backParams = backParams
      switch (name) {
        case 'rename':
          this.renameModal = true
          break
        case 'start':
          this.start()
          break
        case 'restart':
          this.restart()
          break
        case 'stop':
          this.stop()
          break
        case 'pause':
          this.pause()
          break
        case 'unpause':
          this.unpause()
          break
        case 'delete':
          this.delete()
          break
      }
    },
    rename () {
      this.$refs.renameForm.validate((valid) => {
        if (valid) {
          this.renameSubmitting = true
          renameContainer(this.container.Id, this.container.node_id, this.renameForm.name).then(res => {
            this.renameModal = false
            this.renameSubmitting = false
            this.$Notice.success({title: '操作成功！'})
            this.$emit('callback', this.backParams)
          }).catch(res => {
            this.renameSubmitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    start () {
      startContainer(this.container.Id, this.container.node_id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.$emit('callback', this.backParams)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    restart () {
      restartContainer(this.container.Id, this.container.node_id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.$emit('callback', this.backParams)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    stop () {
      stopContainer(this.container.Id, this.container.node_id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.$emit('callback', this.backParams)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    pause () {
      pauseContainer(this.container.Id, this.container.node_id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.$emit('callback', this.backParams)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    unpause () {
      unpauseContainer(this.container.Id, this.container.node_id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.$emit('callback', this.backParams)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    delete () {
      this.$Modal.confirm({
        title: '销毁容器',
        content: '确定要销毁容器「' + this.container.Name + '」吗？',
        onOk: () => {
          deleteContainer(this.container.Id, this.container.node_id).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.$emit('callback', this.backParams)
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .container-action-span {
    padding-left: 10px;
  }
</style>
